import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { errorMessage } from '../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'
import StripeFormSkeleton from '../../components/stripe/StripeFormSkeleton'

// Datacap's card fields come from its script; if they are not there by then, show the frame with an error
const IFRAME_READY_TIMEOUT_MS = 20000

const DefaultComponent = () => <></>
function PGIframeDC(props) {
    const { isSubmittingForm, faciltyData, consent, page, previousButton, APILoad } = props
    // The iframe keeps the callbacks it got when it loaded: read the props of the latest render there
    const latestProps = useRef(props)
    latestProps.current = props

    const [divChilds, setDivChilds] = useState(0)
    const [gatewayError, setGatewayError] = useState('')
    // The Datacap card fields have loaded in the iframe
    const [iframeLoaded, setIframeLoaded] = useState(false)
    const isInitializedRef = useRef(false)
    const scriptPollRef = useRef(null)

    useEffect(() => {
        return () => {
            if (scriptPollRef.current) {
                clearInterval(scriptPollRef.current)
            }
        }
    }, [])

    // Loader until the card fields are there; an error if they never load
    const [loadTimedOut, setLoadTimedOut] = useState(false)
    useEffect(() => {
        if (iframeLoaded) return
        const timer = setTimeout(() => {
            setLoadTimedOut(true)
            setGatewayError('The card form could not be loaded. Please refresh the page and try again.')
        }, IFRAME_READY_TIMEOUT_MS)
        return () => clearTimeout(timer)
    }, [iframeLoaded])
    const isLoadingForm = !iframeLoaded && !loadTimedOut

    useEffect(() => {
        const restrictedDiv = document.getElementById('token-iframe')
        const childCount = restrictedDiv?.children?.length
        setDivChilds(childCount == 0 ? 1 : childCount)
    })

    useEffect(() => {
        function ensureSingleChild(div, newChild) {

            // If the div has more than one child, remove all but the last one
            while (div?.children?.length > 1) {
                div.removeChild(div?.firstElementChild)
            }
            // If the div has no children, simply append the new child
            if (div?.children?.length === 0) {
                div?.appendChild(newChild)
            } else {
                // Otherwise, replace the current child with the new child
                div?.replaceChild(newChild, div.firstElementChild)
            }
        }
        const restrictedDiv = document.getElementById('token-iframe')
        // Example: Adding new content
        const newElement = document.createElement('p')
        // newElement.textContent = 'This is the new single child content.'
        // Call the function to ensure there's only one child in the div
        ensureSingleChild(restrictedDiv, newElement)
        return () => {
        }

    }, [EMPTY_ARRAY, divChilds])

    const initDatacap = () => {
        if (isInitializedRef.current) return
        // Datacap's script can arrive after this component: wait for it instead of failing the init
        if (!window.DatacapHostedWebToken) {
            if (scriptPollRef.current) return // already waiting
            scriptPollRef.current = setInterval(() => {
                if (window.DatacapHostedWebToken) {
                    clearInterval(scriptPollRef.current)
                    scriptPollRef.current = null
                    initDatacap()
                }
            }, 100)
            return
        }
        try {
            isInitializedRef.current = true
            // The facility's own Datacap token key
            window.DatacapHostedWebToken.init(
                faciltyData?.facility_payment_details?.datacap_ecommerce_token, 'token-iframe', getToken()
            )
        } catch (error) {
            isInitializedRef.current = false
            setGatewayError(errorMessage?.somethingWentWrong)
        }
    }

    useEffect(() => {
        if (
            divChilds == 1
        ) {
            initDatacap()
        }
    }, [EMPTY_ARRAY, faciltyData, divChilds])

    const getToken = () => {
        onIFrameLoaded()
        const tokenCallback = (tokenResponse) => {
            return new Promise(function () {
                // setIsSubmittingForm(false)
                if (tokenResponse.Error) {
                    setGatewayError(tokenResponse.Error)
                    return
                }
                var token = tokenResponse.Token
                if (token != '' && token != undefined) {
                    if(latestProps.current.page == 'reservation') {
                        // latestProps.current.setFormData({ ...latestProps.current.formData, 'paymentToken': token })
                        latestProps.current.setValue('paymentToken', tokenResponse)
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            latestProps.current.onSubmit()
                        }
                    } else if(latestProps.current.page == 'permit') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            latestProps.current.setFormData({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                            latestProps.current.onSubmit({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                        }
                    } else if (latestProps.current.page == 'permitRequest') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            latestProps.current.setFormData({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                            latestProps.current.onSubmit({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                        }
                    } else if(latestProps.current.page == 'addCard') {
                        if(APILoad?.current == true) {
                            APILoad.current = false
                            latestProps.current.onSubmit(tokenResponse)
                        }
                    } else {
                        latestProps.current.setFormData({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                        latestProps.current.onSubmit({ ...latestProps.current.formData, 'paymentToken': tokenResponse })
                    }
                    setGatewayError('')
                } else {
                    setGatewayError(errorMessage?.somethingWentWrong)
                }
            }).catch((err) => {
                // setIsSubmittingForm(false)
                setGatewayError(err ? err : errorMessage?.somethingWentWrong)
            })
        }
        return tokenCallback
    }

    let IFrameWindow
    let intervalId

    const onIFrameLoaded = () => {
        const originalOpen = window.open
        window.open = function (url, name, specs) {
            const newWindow = originalOpen(url, name, specs)
            IFrameWindow = newWindow
            // Call API for Storing Logs
            monitorWindowClosed()
            return newWindow
        }
    }

    const monitorWindowClosed = () => {
        intervalId = setInterval(() => {
            if (IFrameWindow && IFrameWindow.closed) {
                // Call API for Storing Logs
                clearInterval(intervalId)
            }
        }, 500)
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Ensure onIFrameLoaded is called after the Google Pay script is loaded
    })

    return (<>
            <div className='card shadow rounded-lg'>
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="card-title">{page == 'addCard' ? 'Card Details' : 'Payment Details'}</h3>
                        <div className="display-td">
                            <img className="img-responsive pull-right" src="https://datacapsystems.github.io/HostedWebToken/accepted.png" />
                        </div>
                    </div>
                </div>
                <div className="card-body" style={{ position: 'relative' }}>
                    {isLoadingForm && <StripeFormSkeleton />}
                    {/* Kept mounted (Datacap fills it) but invisible until its fields have loaded */}
                    <iframe
                        id="token-iframe"
                        frameBorder="0"
                        width={'100%'}
                        height={'225px'}
                        aria-hidden={isLoadingForm}
                        style={isLoadingForm ? { position: 'absolute', top: 0, left: 0, right: 0, opacity: 0, pointerEvents: 'none' } : undefined}
                        // An iframe without src first loads about:blank; ready once Datacap has set its page
                        onLoad={(e) => {
                            if (!e.currentTarget.getAttribute('src')) return
                            setIframeLoaded(true)
                            setLoadTimedOut(false)
                            setGatewayError('')
                        }}
                    ></iframe>
                    <input type="hidden" id="token" />
                    {gatewayError && <div style={{ color: 'red', fontSize: '14px' }}>{gatewayError}</div>}
                    {consent}
                    
                    <div id='q-box__buttons' className='text-center mt-4 d-flex gap-1 justify-content-center'>
                        {previousButton}
                        <button
                            type="button"
                            name="submit"
                            className={(page== 'reservation' || page == 'addCard') ? 'btn btn-primary d-flex step-btn auto-width' : 'btn btn-primary d-flex step-btn'}
                            style={{ opacity: (isSubmittingForm ? true : false) ? '0.8' : '1' }}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                // A new click is a new submit: the previous one may have stopped before resetting APILoad
                                if (APILoad) APILoad.current = true
                                window.DatacapHostedWebToken?.requestToken()
                            }}
                            disabled={(isSubmittingForm || !iframeLoaded) ? true : false}
                        >
                            <div className='d-flex justify-content-center align-items-center'>
                                <span className='mb-0'>{page == 'addCard' ? 'Save Card' : page== 'reservation' ? 'Confirm & Book' : 'Submit'}</span>{isSubmittingForm ? <span className='ms-2'>
                                    <Circles
                                        height="20"
                                        width="20"
                                        style={{ display: 'inline-block' }}
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                </span> : null}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

PGIframeDC.propTypes = {
    dispatch: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    setIsSubmittingForm: PropTypes.func,
    getValues: PropTypes.func,
    faciltyData: PropTypes.object,
    consent: PropTypes.elementType,
    setValue: PropTypes.func,
    previousButton: PropTypes.elementType,
    page: PropTypes.string,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    APILoad: PropTypes.oneOfType([
        PropTypes.func, 
        PropTypes.shape({ current: PropTypes.any })
    ])
}

PGIframeDC.defaulProps = {
    dispatch: noop,
    onSubmit: noop,
    isSubmittingForm: false,
    setIsSubmittingForm: noop,
    getValues: noop,
    faciltyData: EMPTY_OBJECT,
    consent: DefaultComponent,
    setValue: noop,
    previousButton: DefaultComponent,
    page: '',
    formData: EMPTY_OBJECT,
    setFormData: noop,
    APILoad: null
}

function mapStateToProps() {
    return {
    }
}
export default connect(mapStateToProps)(PGIframeDC)